<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="保存"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="年份" prop="year">
          <a-date-picker
            placeholder="请选择年份"
            v-model="form.year"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearyear"
          />
        </a-form-model-item>
        <!-- <a-form-model-item label="成果名称" prop="title">
          <a-input v-model="form.title" />
        </a-form-model-item> -->
        <a-form-model-item label="次数" prop="num">
          <a-input-number
            v-model="form.num"
            min="1"
            precision="0"
            @blur="blurValue"
          />
        </a-form-model-item>
        <!-- <a-form-model-item label="级别" prop="achievement_level">
          <div class="flex">
            <a-select v-model="form.levelType">
              <a-select-option :value="item.text" v-for="item in jblist" :key="item.text">{{
                item.title
              }}</a-select-option>
            </a-select>
            <template v-if="form.levelType == '其他'">
              <a-input v-model="form.otherType" class="ipt-other" />
            </template>
          </div>
        </a-form-model-item> -->
      </a-form-model>
    </div>
  </a-modal>
</template>
    
  <script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        // title: "",
        year: "",
        // achievementType: "",
        num: "",
        // levelType: "",
        // content: "",
        // courseType: "",
        // otherType: "",
      },
      rules: {
         year: [
          {
            validator: (rule, value, callback) => {
              if (this.form.year!='') {
                callback(); // 验证通过
              } else {
                callback(new Error('请选择教研获得年份'));
              }
            },
            required: true,
            message: "请选择教研获得年份",
            //          type: 'string',
            trigger: "change",
          },
        ],
        // title: [
        //   {
        //     required: true,
        //     message: "请输入成果名称",
        //     trigger: "blur",
        //   },
        // ],
        // achievementType: [
        //   {
        //     required: true,
        //     message: "请输入成果类型",
        //     trigger: "change",
        //   },
        // ],
        num: [
          {
            required: true,
            message: "请输入次数",
            trigger: "blur",
          },
        ],
        // levelType: [
        //   {
        //     required: true,
        //     message: "请输入级别",
        //     trigger: "change",
        //   },
        // ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 1,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      jblist: [],
      kclist: [],
      ishow: false,
      ifirst: true,
    };
  },
  components: { BaseEditor },
  mounted() {
    // console.log("111111");
    // console.log(this.rules);
  },
  methods: {
    blurValue() {
      if (this.form.num == "1") {
        this.ifirst = true;
      } else {
        this.ifirst = false;
        this.form.content = "";
      }
    },
    handleClearyear(val) {
      this.form.year = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    handleChange() {
      console.log(this.form.achievementType);
      if (this.form.achievementType == "SZKC") {
        this.ishow = true;
      } else {
        this.ishow = false;
        this.form.courseType = "";
      }
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      const year = moment(value).format('YYYY');
      this.form.year =year+"";
      this.yearShowOne = false;
      // this.form.year = value;
      this.$refs.ruleForm.clearValidate("year");
      // this.yearShowOne = false;
    },
    init(type, record) {
      this.type = type;
      this.visible = true;
      // this.getxwlist();
    //   this.getcgjb();
      // this.getkclist();
      if (type == "add") {
        this.form = {};
        this.form.applyId = record.id;
        this.form.year=new Date().getFullYear()+"";
        this.title = "新增教研情况";
      } else {
        this.title = "编辑教研情况";
        this.form = {
          // title: record?.title,
          // achievementType: record.achievementType,
          num: record.num,
        //   levelType: record.levelType,
        //   courseType: record.courseType,
          // applyId: record.applyId,
          year: record.year,
          id: record.id,
        //   content: record.content,
        //   otherType:record.otherType,
        };
        // if (record.num == "1") {
        //   this.ifirst = true;
        // } else {
        //   this.ifirst = false;
        //   this.form.content = "";
        // }
        
        // if (record.achievementType == "SZKC") {
        //   this.ishow = true;
        // } else {
        //   this.ishow = false;
        //   this.form.courseType = "";
        // }
        //       if (record.content!='' && record.content!=null ){
        //           this.$nextTick(() => {
        //             this.$refs.baseEditor[0].value = record.content;
        //           })
        //       }
      }
    },
    handleCancel() {
      this.visible = false;
      //     this.yearShowOne = false;
    },
    getxwlist(ids) {
      getAction("/baseCommon/getDictItemsByCode?code=achievement_type").then(
        (res) => {
          if (res.code == 200) {
            this.xwlist = res.result;
          }
        }
      );
    },
    getcgjb() {
      getAction("/baseCommon/getDictItemsByCode?code=achievement_level",).then((res) => {
      	if (res.code == 200) {
      		this.jblist=res.result;
      	}
      });
    },
    getkclist() {
      getAction("/baseCommon/getDictItemsByCode?code=apply_course_type").then(
        (res) => {
          if (res.code == 200) {
            this.kclist = res.result;
          }
        }
      );
    },
    submit() {
      //  	this.$refs.ruleForm.clearValidate();
      console.log(typeof this.form.year);
      if (
        typeof this.form.year == "object" &&
        this.form.year != "" &&
        this.type == "add"
      ) {
        this.form.year =
          new Date(this.form.year).getFullYear() + "";
      }
      this.$refs.ruleForm.validate((valid) => {
        //    	console.log(valid);
        if (valid) {
          //					this.yearShowOne = false;
          if (this.type == "add") {
            let params = this.form;
            // params.applyType = this.applyType;
            this.visible = false;
            this.$message.success("添加成功");
            this.$emit("addGain", { record: params, type: 'add' });
            // postAction("/lxbase/lxTeachingResearchSituation/add", params).then((res) => {
            //   if (res.code == 200) {
            //     this.visible = false;
            //     this.$message.success("添加成功");
            //     this.$emit("addGain");
            //   } else {
            //     this.$message.error(res.message);
            //   }
            // });
          } else {
            let params = this.form;
            //params.applyId = "1829722136428707841";
            if (typeof this.form.year == "object") {
              params.year =
                new Date(this.form.year).getFullYear() + "";
            }
            params.applyType = this.applyType;
            this.visible = false;
            this.$message.success("编辑成功");
            this.$emit("addGain", { record: params, type: 'edit' });
            // putAction("/lxbase/lxTeachingResearchSituation/edit", params).then((res) => {
            //   if (res.code == 200) {
            //     this.visible = false;
            //     this.$message.success("编辑成功");
            //     this.$emit("addGain");
            //   } else {
            //     this.$message.error(res.message);
            //   }
            // });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
.ipt-other {
  margin-left: 12px;
}
</style>
  